module.exports = "hr {\n    margin: 0.5em 0;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modals/deployment-confirmation/deployment-confirmation.modal.component.css
// module id = 911
// module chunks = 4